(
    function() {
        module.exports = {
            sendIrisTracking: function() {
                if (JSON.parse(!Odigeo.Utils.isWebmasterPage())) {
                    let environment = ['edreams', 'travellink', 'opodo', 'govoyages']
                        .some((domain) => window.location.href.indexOf(domain) !== -1) ? 'prod-edo' : 'qa-edo';
                    const Iris = require('iris-agent');
                    Iris.init(
                        environment,
                        {
                            targetUrl: 'https://ingestion.odigeoconnect.com/iris/iris/iris.gif',
                            useBeacon: true,
                        });

                    Iris.fire('pageView', {page: 'home',
                        homeVersion: Odigeo.Session.get('of_home_version')});
                }
            },
        };
    }
)();
